import React, { useState } from "react";
import { motion } from "framer-motion";
import NewsletterModal from "../NewsletterModal";

export default function StorySection() {
  const [isNewsletterOpen, setIsNewsletterOpen] = useState(false);

  return (
    <>
      <section className="relative py-12 md:py-20 px-6 md:px-12 lg:px-24 overflow-hidden">
        <div className="max-w-[1600px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center justify-items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="space-y-6 flex flex-col items-center text-center max-w-2xl"
            >
              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#D3242A] uppercase leading-tight text-center"
                style={{ 
                  fontFamily: "Geogrotesque, sans-serif"
                }}
              >
                MEET RUGGED RED
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
                className="text-lg md:text-xl text-gray-700 leading-relaxed"
              >
                Rugged Red isn't a mascot—he's the real deal. A seasoned pro who's led industrial and commercial cleaning crews for decades. From greasy kitchen hoods to construction trailers, office carpets to factory floors—he's seen it all, and cleaned it all.
              </motion.p>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
                className="text-lg md:text-xl text-gray-700 leading-relaxed"
              >
                Over the years, he's tested hundreds of cleaners. Most didn't cut it. So, he got to work—refining, mixing, and field-testing until he landed on something better. A formula tough enough for the job, safe enough to trust around people, and made entirely from natural ingredients.
              </motion.p>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.8 }}
                className="text-lg md:text-xl text-gray-700 leading-relaxed"
              >
                Now, his proven formulas are available to the public. No gimmicks. Just powerful, professional-grade cleaners that work—backed by a lifetime of experience.
              </motion.p>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.0 }}
                className="text-lg md:text-xl text-gray-700 leading-relaxed font-semibold"
              >
                Introducing Rugged Red Cleaners.
              </motion.p>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.2 }}
                className="text-lg md:text-xl text-gray-700 leading-relaxed font-semibold"
              >
                A Proven Powerful Clean
              </motion.p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="flex justify-center items-center w-full"
            >
              <img
                src="/images/Rugged Red Logo Mr. Rugged Red Small- Interlock Dynamic.png"
                alt="RuggedRed Mascot"
                className="w-full max-w-[280px] md:max-w-md lg:max-w-[500px] rounded-2xl [filter:drop-shadow(0_20px_13px_rgb(0_0_0_/_0.3))]"
              />
            </motion.div>
          </div>
        </div>
      </section>
      <NewsletterModal 
        isOpen={isNewsletterOpen} 
        onClose={() => setIsNewsletterOpen(false)} 
      />
    </>
  );
}